'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageNature = function ImageNature(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 16.12c3.47-.41 6.17-3.36 6.17-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H5v2h14v-2h-6v-3.88z' })
  );
};
ImageNature = (0, _pure2.default)(ImageNature);
ImageNature.displayName = 'ImageNature';
ImageNature.muiName = 'SvgIcon';

exports.default = ImageNature;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/image/nature.js
// module id = 3163
// module chunks = 0